import { ImageWithPlaceholder, Typography } from '@wbk/ui';
import { type WebSection } from '@wbk/contentful/api';

import HeroTitle from '../ui/HeroTitle';

type Props = {
  section?: WebSection;
};
const ZonesHeroSection = ({ section }: Props) => {
  return (
    <>
      <div className='relative h-[95dvh]'>
        <div className='absolute inset-0'>
          <div className='pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-black/40 to-black/80 mix-blend-multiply' />
          <ImageWithPlaceholder
            alt='explore hero'
            className='h-full w-full object-cover'
            src={section?.sectionBackground?.url}
          />
        </div>
        <div className='container-padding container h-full w-full'>
          <div className='container relative flex h-full w-full flex-col gap-4'>
            <div className='absolute inset-x-0 bottom-20'>
              <div className='flex h-full w-full flex-col items-start justify-between gap-6 lg:flex-row lg:items-end'>
                <div className='space-y-6 text-nowrap lg:space-y-10 rtl:space-y-4'>
                  {section?.title && <HeroTitle className='uppercase' title={section?.title} />}
                </div>

                <Typography
                  as='div'
                  className='!text-body-S xl:!text-body-M 2xl:!text-body-L h-fit w-full justify-end text-[#A1A1AA] lg:w-[40%]'
                >
                  {section?.subtitle && section?.subtitle}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZonesHeroSection;
